import * as cs from 'classnames';
import * as React from 'react';
import { HTMLAttributes } from 'react';
import { connect } from 'react-redux';
import { AnyAction, bindActionCreators, Dispatch } from 'redux';
import { Spinner } from '../common/Spinner';
import { StoreStateWithRouter } from '../store/StoreState';
import { Banner, BannerDispatchProps } from './Banner';
import './Menu.css';
import { MainMenu } from './MenuItems';
import { MenuState } from './MenuState';
import { Location } from 'history';
import { menuActions } from './MenuActions';

interface MenuProps extends MenuState, Location {
}

interface MenuDispatchProps extends BannerDispatchProps {
}

export const Menu: React.FC<MenuProps & MenuDispatchProps & HTMLAttributes<HTMLDivElement>> = (
    {
        onToggle,
        menuItems = [],
        className,
        pathname,
        expanded,
        loaded
    }) => (
    <div className={cs('menu', className)}>
        <Spinner hide={loaded}/>
        <Banner onToggle={onToggle} expanded={expanded}/>
        <MainMenu menuItems={menuItems} currentPathname={pathname} expanded={expanded}/>
    </div>
);

function mapStateToProps(state: StoreStateWithRouter): MenuProps {
    return {...state.menu, ...state.router.location};
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>): MenuDispatchProps {
    return bindActionCreators(
        {onToggle: menuActions.menuBarToggled},
        dispatch
    );
}

export default connect<MenuProps, MenuDispatchProps>(mapStateToProps, mapDispatchToProps)(Menu);


// WEBPACK FOOTER //
// ./src/menu/Menu.tsx